export enum CONTRACT_STATUS {
  LIQUIDATION = 'ENLIQUIDATION',
  INPROGRESS = 'ENCOURS',
}
